"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseTheme = void 0;
const material_1 = require("@mui/material");
const colors_1 = require("../tokens/colors");
const typography_1 = require("../tokens/typography");
const baseThemeOptions = {
    direction: 'ltr',
    components: {
        MuiAvatar: {
            styleOverrides: {
                fallback: {
                    height: '75%',
                    width: '75%',
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    padding: '16px 0',
                    fontSize: typography_1.typography.body1.fontSize,
                    fontWeight: typography_1.typography.body1.fontWeight,
                    letterSpacing: typography_1.typography.body1.letterSpacing,
                    'li:last-of-type > a': {
                        fontWeight: 700,
                    },
                },
                separator: {
                    fontWeight: 700,
                    marginLeft: '16px',
                    marginRight: '16px',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontSize: typography_1.typography.body2.fontSize,
                    fontWeight: typography_1.typography.body2.fontWeight,
                    letterSpacing: typography_1.typography.body2.letterSpacing,
                    padding: '6px 4px',
                    '.MuiChip-label': {
                        padding: '0 8px',
                        fontSize: 'inherit',
                    },
                    '&.MuiChip-deletable': {
                        paddingRight: '6px',
                    },
                    '&.MuiChip-sizeSmall': {
                        fontSize: typography_1.typography.caption.fontSize,
                        padding: '2px 4px',
                        '.MuiAvatar-root': {
                            marginLeft: '3px',
                        },
                    },
                    '&.MuiChip-sizeMedium': {
                        fontSize: typography_1.typography.buttonMedium.fontSize,
                        '.MuiAvatar-root': {
                            marginLeft: '1.5px',
                        },
                    },
                    '.MuiAvatar-root': {
                        marginRight: '0',
                    },
                    '.MuiChip-deleteIcon': {
                        opacity: '0.8',
                        margin: 0,
                    },
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    boxSizing: 'border-box',
                },
                html: {
                    MozOsxFontSmoothing: 'grayscale',
                    WebkitFontSmoothing: 'antialiased',
                    height: '100%',
                    width: '100%',
                },
                body: {
                    height: '100%',
                },
                '#root': {
                    height: '100%',
                },
                '#nprogress .bar': {
                    zIndex: '2000 !important',
                },
            },
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: {
                    variant: 'h6',
                },
                subheaderTypographyProps: {
                    variant: 'subtitle2',
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    overflow: 'hidden',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    width: '20px',
                    height: '20px',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: typography_1.typography.body1.fontSize,
                    fontWeight: typography_1.typography.body1.fontWeight,
                    letterSpacing: typography_1.typography.body1.letterSpacing,
                    lineHeight: '24px',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    color: colors_1.colors.grey[300],
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontSize: typography_1.typography.body2.fontSize,
                    lineHeight: '24px',
                    textTransform: 'none',
                },
            },
        },
    },
    typography: {
        h1: typography_1.typography.h1,
        h2: typography_1.typography.h2,
        h3: typography_1.typography.h3,
        h4: typography_1.typography.h4,
        h5: typography_1.typography.h5,
        h6: typography_1.typography.h6,
        subtitle1: typography_1.typography.subtitle1,
        subtitle2: typography_1.typography.subtitle2,
        body1: typography_1.typography.body1,
        body2: typography_1.typography.body2,
        caption: typography_1.typography.caption,
        overline: typography_1.typography.overline,
    },
};
exports.baseTheme = (0, material_1.createTheme)(baseThemeOptions);
//# sourceMappingURL=base-theme.js.map